import React from 'react';
import classnames from 'classnames';
import FormLabel from 'v2/form/FormLabel/FormLabel';
import MultiSelectFiles from 'v2/form/CustomSelectors/Multiselect/MultiSelectFiles';
import { Control, Controller } from 'react-hook-form';
import styles from './aiSearchModal.module.scss';
import { AISearchRequiresFiles } from 'v2/utils/AISearchUtils';
import { FileType, ItemList } from 'v2/models';
import { AISearchFormFields } from './AISearchSchema';

interface AISearchFilesProps {
  fileTypes: FileType[];
  companyList: ItemList;
  isFilesDisabled: boolean;
  searchType: string;
  control: Control<AISearchFormFields>;
  validateInput: (value: ItemList) => boolean;
  defaultValues: ItemList;
}
const AISearchFiles = ({
  fileTypes,
  companyList,
  isFilesDisabled,
  searchType,
  control,
  validateInput,
  defaultValues,
}: AISearchFilesProps) => {
  if (!AISearchRequiresFiles[searchType]) {
    return null;
  }

  return (
    <>
      <FormLabel
        label={`Which files would you like to search?`}
        required={false}
        className={classnames('mt-4', styles.label, {
          [styles.disabled]: isFilesDisabled,
        })}
      />
      <Controller
        name="fileList"
        control={control}
        rules={{
          required: true,
          validate: validateInput,
        }}
        render={({ field: { onChange } }) => {
          return (
            <MultiSelectFiles
              fileTypes={fileTypes}
              dataVendorId={
                companyList.list.length === 1
                  ? companyList.list[0].id
                  : undefined
              }
              onChange={onChange}
              defaultValues={defaultValues}
              disabled={isFilesDisabled}
            />
          );
        }}
      />
    </>
  );
};

export default AISearchFiles;
